import { PointStyle } from '../models';
import { SpecialPointType } from '../enums';

export const POINT_STYLES = new Map<SpecialPointType, PointStyle>([
    [SpecialPointType.MotorOperation, {
        shape: 'circle',
        radius: 5,
        hoverRadius: 7,
        backgroundColor: '#00B0F0',
        borderColor: '#00B0F0',
        borderWidth: 2,
        hoverBorderWidth: 2
    } as PointStyle],
    [SpecialPointType.LoadOperation, {
        shape: 'circle',
        radius: 7,
        hoverRadius: 9,
        backgroundColor: '#7F6000',
        borderColor: '#7F6000',
        borderWidth: 2,
        hoverBorderWidth: 2
    } as PointStyle],
    [SpecialPointType.LoadSwitching, {
        shape: 'rect',
        radius: 5,
        hoverRadius: 7,
        backgroundColor: '#965223',
        borderColor: '#BC672C',
        borderWidth: 2,
        hoverBorderWidth: 2
    } as PointStyle],
    [SpecialPointType.LoadPower, {
        shape: 'circle',
        radius: 5,
        hoverRadius: 7,
        backgroundColor: '#EE3C00',
        borderColor: '#FF5319',
        borderWidth: 2,
        hoverBorderWidth: 2
    } as PointStyle],
    [SpecialPointType.RatedPoint, {
        shape: 'circle',
        radius: 9,
        hoverRadius: 11,
        backgroundColor: '#00B050',
        borderColor: '#00B050',
        borderWidth: 2,
        hoverBorderWidth: 2
    } as PointStyle],
    [SpecialPointType.MotorAndLoadOperation, {
        shape: 'circle',
        radius: 7,
        hoverRadius: 9,
        backgroundColor: '#7F6000',
        borderColor: '#00B0F0',
        borderWidth: 2,
        hoverBorderWidth: 2
    } as PointStyle]
]);
